<template>
  <div class="retake--wrap">
    <content-box class="bLogin"
                 :class="`state__${state}`"
                 :width="'430px'">
      <template v-if="state === 'ing'">
        <ui-loading-circle>
          <span v-html="$t('lnb.claimIssue.retake.bLoginTrue.ing.desc')"></span>
        </ui-loading-circle>
      </template>

      <template v-else-if="state === 'success'">
        <i class="icon icon--camera-size50"></i>
        <p class="title" v-html="$t('lnb.claimIssue.retake.bLoginTrue.success.title')"></p>
        <p class="desc" v-html="$t('lnb.claimIssue.retake.bLoginTrue.success.desc')"></p>
        <ui-button
          @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
      </template>

      <template v-else>
        <i class="icon icon--camera-error-size50"></i>
        <p class="title" v-html="$t('lnb.claimIssue.retake.bLoginTrue.fail.title')"></p>
        <p class="desc" v-html="$t('lnb.claimIssue.retake.bLoginTrue.fail.desc')"></p>
        <ui-button
          @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
      </template>
    </content-box>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import { login } from '@/api/capture'

export default {
  components: {
    ContentBox,
    UiButton,
    UiLoadingCircle
  },
  props: [
    'aid',
    'url',
    'captureUrl'
  ],
  data () {
    return {
      state: 'ing' // ing, success, fail
    }
  },
  methods: {
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  },
  created () {
    let param = {
      aid: this.aid,
      url: this.captureUrl || this.url
    }
    login(param).then(response => {
      this.state = 'success'
    }).catch(err => {
      console.error(err)
      this.state = 'fail'
    })
  }
}
</script>

<style lang="scss" scoped="scoped">
.retake--wrap {
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444444;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }
  .bLogin {
    text-align: center;
    position: relative;
    box-sizing: border-box;

    &.state__ing {
      /deep/ .loading.position {
        top: 100px;
        transform: translate(-50%, 0);
        .desc {
          white-space: nowrap;
          font-size: 14px;
          color: #2f2f2f;
        }
      }
    }

    &.state__success {
      padding-top: 50px;
      padding-bottom: 25px;
      .title {
        margin-top: 15px;
      }
      .desc {
        margin-top: 12px;
      }
      .ui-btn {
        margin-top: 40px;
      }
    }

    &.state__fail {
      padding-top: 50px;
      padding-bottom: 25px;
      .title {
        margin-top: 15px;
      }
      .desc {
        margin-top: 12px;
      }
      .ui-btn {
        margin-top: 60px;
      }
    }
  }
}
</style>
